import {Component} from '../../core';
import constants from '../../cityConstant.js';
import {isSet,seoUrl,isEmpty} from '../../utils/common';
import {CoworkDynamicContactComponent} from './cowork-dynamic-contact.component'; 

/**
 * Coworkhome Featured spaces component
 */
export class CoworkFeaturedSpacesComponent extends Component {

    static alias = 'cowork-home-featured-spaces';

    constructor(el) {
        super(el);
    }

    onComponentLoaded() {

        // Initialize the featured spaces
        this.initializeFeaturedSpaces();
    }

    initializeFeaturedSpaces(){
        let cityId = '';
        if(globals.cityId != 1) {
            cityId = globals.cityId;
        }
        this.fetchFeaturedSpaces(cityId).then((featuredSpaces) => {
            // Update the state
            this.setState({...this.state, featuredSpaces});
            
            // Render featured spaces
            this.renderFeaturedSpaces(this.state.featuredSpaces);

            this.initializeContactsEventFs();
        });
    }

    slickLoad() {
        $(".single-item").slick({
                dots: false,
                infinite: true,
                slidesToShow: 4,
                slidesToScroll: 4,
                responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                    slidesToShow: 3,
                    centerMode: false,
                    variableWidth: true,
                    slidesToScroll: 3,
                    dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                    slidesToShow: 2,
                    centerMode: false,
                    variableWidth: true,
                    slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                    slidesToShow: 1,
                    centerMode: false,
                    variableWidth: true,
                    slidesToScroll: 1
                    }
                }
                ]
            });
    }

    fetchFeaturedSpaces(cityId) {
        // Render featured spaces
        return fetch(`/homes/re2/coworkFeaturedSpaces?cityId=${cityId}`).then((res) => res.json());
    }

    /**
     * Renders featured spaces
     * @param {Array} featured spaces 
     */
    renderFeaturedSpaces(featuredSpaces = []) {

        this.refs.featuredSpaces.innerHTML = featuredSpaces.reduce((html, response) => html + `
           <div>
                <div class="cw_fs_tile">
                    <a onclick="coworkGa('QH_CoWork','Homepage_CoWork_Center-tile', 'QH_CoWork_Homepage_Center-tile_featured-spaces_Click');" href="${this.getUrl(response)}" >
                        <div class="cw_fs_img_wrapper">
                        ${this.getImageUrl(response)}
                        </div>
                        ${this.checkOffers(response.offers)}
                        <h3>${response.propertyName}</h3>
                        <p class="cw_fs_t_loc">${response.localityName}, ${response.cityName}</p>
                    </a>
                    <div class="cw_fs_tile_bottom clearfix">
                        <a href="${this.getUrl(response)}" >
                            ${this.getPrice(response.offers)}
                        </a>
                        <button type="button" class="enquiryinitfs cwbtn ttuc" data-ref-id="${response.id}" data-ref-leaddetail="${this.getEncodeFormat(response)}" data-ref="enquiryinit" data-toggle="modal" data-target="#co_workEnquiryPopup" id="booktour${response.id}">Enquiry</button>
                    </div>
                </div>
            </div>`, ''
            );

        if(isEmpty(this.refs.featuredSpaces.innerHTML)){
            document.getElementById("featuredSpacesSection").classList.add('hide');
        }

        if(globals.pageType != "CoworkSNB") {
            this.slickLoad();
        }
    }

    getPrice(response){
        let price = '';
        if(!isEmpty(response.minPrice)){
            price = `<span class="fs_t_sa">Starting at</span>
                            <h4 class="fs_t_pr">${response.minPrice}<small>/month</small></h4>`;
        }
        return price;
    }

    getImageUrl(response) {
        if(response.media && response.media.length>0 ) {
            let image = response.media[0].url.replace("80x80","300x300");
            return `<img src="${image}" />`;
        } else {
            return `<img class="defualt_img" src="${window.CDNURL}/image/QC_DefaultImage.jpg" />`
        }
    }

    /**
     * generate urls for vap page
     */
    getUrl(response){
        if(response.propertyName == '91 Spring Board' || response.propertyName == '91springboard Coworking Space') {
            return "https://www.quikr.com/cars-bikes/partnerships/91springboard";
        } else {
            let locality = (response.localityName).replace(/\s+/g, '-').toLowerCase();
            let city = (response.cityName).replace(/\s+/g, '-').toLowerCase();
            let propertyName = (response.propertyName).replace(/\s+/g, '-').toLowerCase();
            return `//www.quikr.com/coworking/listing/${propertyName}-${locality}-${city}-${response.id}`;
        }
    }

    getEncodeFormat(response){
        return btoa(JSON.stringify(response));
    }

    checkOffers(offers){
        var offer = '';
        if(!isEmpty(offers) && offers.length >0){
            offer = '<div class="offer_box mrtp10 poscale">Offers Inside</div>';
        }
        return offer;
    }

    initializeContactsEventFs() {
        var classname = document.getElementsByClassName("enquiryinitfs");
        Array.from(classname).forEach((element) => {
          element.addEventListener('click', this.initializeContactFormWithPropertyId.bind(this));
        });
    }

    initializeContactFormWithPropertyId(ev) {
        document.getElementById('co_workEnquiryPopup').innerHTML = '';
        // Initialize the contact form
        this.fetchContact().then((response) => {
            document.getElementById('co_workEnquiryPopup').innerHTML = response;
            let propertyId = ev.target.getAttribute("data-ref-id");
            let propertyDetail = ev.target.getAttribute("data-ref-leaddetail");
            let typeval = 'featured-spaces';
            if(document.getElementById('contactDynamicFormId')) {
                document.getElementById('contactDynamicFormId').setAttribute('data-component', 'cowork-dynamic-contact' + propertyId);
            }
            const contactComponent = new CoworkDynamicContactComponent(null, {propertyId, propertyDetail, typeval});
        });
    }

    fetchContact() {
        return fetch(`/homes/re2/coworkcontact?aj=1`).then((res) => res.text());
    }



}